import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ element, roles = [] }) => {
  const { token, loading, user } = useAuth();

  const normalizedRoles = (user?.roles || []).map((r) => (r === "OWNER" ? "ADMIN" : r));

  const isPublic = roles.includes("PUBLIC");

  if (isPublic) {
    if (!token) {
      return element;
    }

    if (loading || !user || !normalizedRoles.length) {
      return null;
    }

    let redirectPath = "/subjects/base";

    if (normalizedRoles.includes("STUDENT")) {
      redirectPath = "/exams/my";
    } else if (normalizedRoles.includes("TEACHER")) {
      redirectPath = "/lessons";
    } else if (normalizedRoles.includes("COORDINATOR") || normalizedRoles.includes("ADMIN")) {
      redirectPath = "/subjects/base";
    }

    return <Navigate to={redirectPath} replace />;
  }

  if (loading) {
    return null;
  }

  if (!token) {
    return <Navigate to="/login" replace />;
  }

   if (!user || !normalizedRoles.length) {
    return <Navigate to="/login" replace />;
  }


  if (roles.length > 0) {
    const hasRole = normalizedRoles.some((role) => roles.includes(role));
    if (!hasRole) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return element;
};

export default ProtectedRoute;
